var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.region)?_c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': `${_vm.paddingTop}px`,
    'padding-bottom': `${_vm.paddingBottom}px`
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('point-map',{attrs:{"region":_vm.region,"shops":_vm.region.shops,"hide-button":_vm.hideButton}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }